module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params && _vm.params.isActive) ? _c('div', [_c('ModalDefault', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "close": function($event) {
        _vm.close();
      }
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center container flex-column"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t("common.create")))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('DefaultTextInputBloc', {
    attrs: {
      "label": _vm.$t('zone.name'),
      "required": true,
      "max-length": 99
    },
    model: {
      value: (_vm.zoneGroupName),
      callback: function($$v) {
        _vm.zoneGroupName = $$v
      },
      expression: "zoneGroupName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mt-4 admin-role-switch-client-admin"
  }, [_c('label', {
    staticClass: "switch switch-m",
    attrs: {
      "for": "zonesForRight"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forRight),
      expression: "forRight"
    }],
    attrs: {
      "type": "checkbox",
      "id": "zonesForRight"
    },
    domProps: {
      "checked": _vm.forRight,
      "checked": Array.isArray(_vm.forRight) ? _vm._i(_vm.forRight, null) > -1 : (_vm.forRight)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.forRight,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forRight = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.forRight = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forRight = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round",
    style: ({
      'background-color': _vm.forRight ? _vm.currentBrand.linksColor : ''
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.$t("zoneGroups.zonesForRight")))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mt-4 admin-role-switch-client-admin"
  }, [_c('label', {
    staticClass: "switch switch-m",
    attrs: {
      "for": "zonesForDashboard"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forDashboard),
      expression: "forDashboard"
    }],
    attrs: {
      "type": "checkbox",
      "id": "zonesForDashboard"
    },
    domProps: {
      "checked": _vm.forDashboard,
      "checked": Array.isArray(_vm.forDashboard) ? _vm._i(_vm.forDashboard, null) > -1 : (_vm.forDashboard)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.forDashboard,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forDashboard = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.forDashboard = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forDashboard = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round",
    style: ({
      'background-color': _vm.forDashboard ? _vm.currentBrand.linksColor : ''
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.$t("zoneGroups.zonesForDashboard")))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('ClientColorButton', {
    staticClass: "mr-3",
    attrs: {
      "inactiveColor": !_vm.isFormValidated,
      "background-color": _vm.currentBrand.linksColor,
      "disabled": !_vm.isFormValidated
    },
    on: {
      "click": function($event) {
        _vm.saveZoneGroups();
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("common.save")) + "\n                    ")]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "inactiveColor": true
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("actions.cancel")))])], 1)])])], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4095bff1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/zoneGroups/CreateZoneGroups.vue
// module id = 3142
// module chunks = 0